<template>
  <div class="flex justify-between mt-3 mb-5 gap-x-[10px]">
    <van-button class="primaryBtn_transparent" @click="props.onCancel()">
      {{ props.cancelText }}
    </van-button>
    <van-button class="primaryBtn" @click="props.onConfirm()">
      {{ props.confirmText }}
    </van-button>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  onCancel: {
    type: Function,
    required: true,
  },
  cancelText: {
    type: String,
    default: "Cancelar",
  },
  onConfirm: {
    type: Function,
    required: true,
  },
  confirmText: {
    type: String,
    default: "Confirme",
  },
});
</script>

<style lang="scss" scoped></style>
